
<template>
    <div class="c-header-dark" role="banner">
        <div class="c-header__inner client-header__inner" style="padding: 0.5rem">  
            <router-link 
                class="header-image__container" 
                style="cursor:pointer"
                tag="img" 
                to="/"
                :src="imgPath + 'pw-blbg-logo.svg'"
            />

            <div class="vertical-separator"/>
            <img class="header-image__container" :src="imgPath + 'pw-logo.svg'"/>

            <div v-if="isVisible" class="c-primary-nav__item" style="align-items:center">
              <tr>
                <td class="td-value"> </td>
                <td class="td-field">Available Clients:</td>
                <td class="td-value">
                  <div class="client-dropdown">
                    <select class="c-input--select" @change="changeClient" style="width: 300px;" v-model="clientSelection">
                        <option 
                            v-for="(client,idx) in client_NAMES"
                            :key="idx"
                            :value="idx"
                            :selected="client==clientName"
                        >
                            <span>{{client}}</span>
                        </option>
                    </select>
                  </div>
                </td>
              </tr>
            </div>

            <div class="c-header__nav-container js-nav-panel">
                <ul class="c-primary-nav__list-left js-nav-panel" role="tablist" aria-multiselectable="true"> <!-- tab list -->
                    <li v-bind:key="item.id" v-for="item in headerItems" class="c-primary-nav__item">
                        <div @click="makeActive(item.id)"> 
                            <router-link
                                :to="item.redirectUrl"
                                tag="a"
                                class="c-primary-nav__link"
                                exact
                            >
                                <div>
                                    <div class="c-primary-nav__text">
                                        {{item.title}}
                                    </div>
                                    <div :class="`${item.isActive ? 'active-tab' : ''}`"/>
                                </div>
                            </router-link>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- We need to assert these display only when the desired clients are logged in. -->
            <div v-if="isVisible" id="dropdownProfile" class="c-primary-nav__item" style="align-items:center" @click="showLossContent">
                <div class="username-display c-primary-nav__text">Losses</div>
                <div id="dropdownMenuitem" class="loss-dropdown-content">
                    <router-link to="/lossCalc" ><span class="menu-item--clickable">Loss Calculator</span></router-link>
                    <router-link to="/lossRuns" ><span class="menu-item--clickable">Loss Run</span></router-link>
                </div>     
            </div>
            <div id="dropdownProfile2" class="c-primary-nav__item" style="align-items:center"  @click="showContent">
                <div class="username-display c-primary-nav__text">{{ userName }}</div>
                <div class="client-display c-primary-nav__text">{{targetClientName}}</div>
                <div class="c-icon--large">
                    <img :src="imgPath + 'pw-icon-user.svg'"/>
                </div>           
            
                <div id="dropdownMenuitem2" class="dropdown-content" >
                    <router-link to="/profile" ><span class="menu-item--clickable">Profile</span></router-link>
                    <span class="menu-item--clickable" @click="logout"> Sign Out</span>
                </div>     
            </div>
        </div>
    </div>
</template>

<script>
import { isLoaded, setLoaded, waitForToken, axiosRequests } from '@ClientPortal/main.js'
import _ from 'lodash'

export default {
    async beforeMount() {
        var securityProfile="prod,security-okta".split(",") //process.env.SECURITY_PROFILE.split(","),
        if(securityProfile.includes('security-okta')){
            await this.isAuthenticated()
            await this.setup()
            this.$auth.authStateManager.subscribe(this.isAuthenticated)
        }
        else if(securityProfile.includes('security-db')){
            const token = localStorage.getItem("token")
            axiosRequests.defaults.headers.authorization = token
            
            axiosRequests.get().then((resp)=>{
                if(resp.status == 200){
                    this.$store.dispatch('loginFromToken', { token })
                    this.authenticated = true
                }
            }).catch(() =>{
                    this.$store.dispatch('logout')
                    this.$store.dispatch('setSystemMessage', {message: "You have been logged out. Please enter your credentials."})
                    this.authenticated = false
                }
            )

        } 
        //security-off profile default behaviour
        else {
            // TODO: Use webpack to strip this code block in production
            axiosRequests.get().then(
            (resp)=>{
                    // If authorization header is empty and resp is 200, security-off profile is active
                    if(resp.status == 200){
                        const token = "STUB-JWT.eyJzdWIiOiIwIiwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhvcml0aWVzIjpbIlJPTEVfQURNSU4iLCJSRUFEIiwiQ1JFQVRFIiwiREVMRVRFIiwiVVBEQVRFIl19.UNSIGNED"
                        this.$store.dispatch('loginFromToken', { token })
                    }
                    this.authenticated = true
            }).catch(
                () => {
                    this.authenticated = false
                    this.$store.dispatch('logout')
            })
        }

    },
    computed:{
        clientName(){
            return this.$store.state.clientName ? this.$store.state.clientName : this.fetchClientName()
        }, 
        userName(){
            return this.$store.state.user ? this.$store.state.user.username : this.fetchUserName()
        },
        targetClientName(){
          var clientId = this.$store.state.user ? this.$store.state.user.clientId : this.fetchClientId()
          var clientName = this.$store.state.user ? this.$store.state.user.clientName : this.fetchClientName()
          var isEnhanced = this.userInfo ? this.userInfo.isEnhanced : this.fetchIsEnhanced()
          axiosRequests.get(`/isEnhanced?userProfile=${isEnhanced}`)
             .then(response => {
              this.isEnhancedUserResponse = response.data
          })
          if(this.isEnhancedUserResponse != "") {
            this.isVisible = true
            return this.isEnhancedUserResponse
          }
          var stateClient = localStorage.getItem("stateClient")
          for (let i = 0; i < this.userInfo.client_IDS.length; i++) {
            if(stateClient == this.userInfo.client_IDS[i]) {
              //console.log(`RGD: ${this.userInfo.client_NAMES[i]}`)
              return this.userInfo.client_NAMES[i]
            }
          }
          //console.log(`RGD: ${clientName}`)
          return clientName
        },
        client_NAMES(){
          if(this.userInfo && this.userInfo.client_NAMES) {
            return this.userInfo.client_NAMES
          } else {
            var client_NAMES = this.fetchClientNAMES()
            return client_NAMES
          }
        }
    },
    created(){
        //Changing selected tab in case of case page drill down
        if(window.location.href.includes('cases')){
            this.headerItems.forEach(it => {
                it.isActive = it.title=='Cases' ? true : false
            })
        }
        this.addClickOutsideToClose()
        if(isLoaded() == false) {
          setLoaded(true)
        }
    },
    beforeMount() {
      // Read prior state on init.
      //var stateClient = localStorage.getItem("stateClient")
      //console.log(`RGD: beforeMount ${stateClient}`)
      this.clientSelection = localStorage.getItem("clientSelection")
      if(this.clientSelection == null) {
        this.clientSelection = 0
      }
    },
    mounted() {
      // Read prior state on init.
      this.clientSelection = localStorage.getItem("clientSelection")
      if(this.clientSelection == null) {
        this.clientSelection = 0
      }
    },
    data() {
        var clientId = this.$store.state.user ? this.$store.state.user.clientId : this.fetchClientId()
        return {
            isEnhancedUserResponse: "",
            isVisible: false,
            clientSelection: 0,
            isActive: false,
            isAdmin: this.$store.getters.isAdmin,
            chooseClient: false,
            clientList: null,
            userInfo: this.$store.state.user,
            imgPath: process.env.IMAGES_PATH,
            headerItems: [
                {   
                    id: 1,
                    title: "Home",
                    redirectUrl: "/",
                    isActive: true
                },
                {
                    id: 2,
                    title: "US & Global Cases",
                    redirectUrl: "/cases",
                    isActive: false
                },
                {
                    id: 3,
                    title: "Settlements",
                    redirectUrl: "/settlements",
                    isActive: false
                },
                {
                    id: 4,
                    title: "Repose Tracker",
                    redirectUrl: "/reposeTracker",
                    isActive: false
                },
                {
                    id: 5,
                    title: "Reports",
                    redirectUrl: "/reports",
                    isActive: false
                }
            ]
        }
    },
    
    methods: {
        async isAuthenticated () {
            this.authenticated = await this.$auth.isAuthenticated()
        },
        async setup(){
            if(!this.authenticated && (this.securityProfile.includes('security-okta')))
            {
                const token = await this.$auth.tokenManager.getTokens()
                const claims = await this.$auth.getUser(token.accessToken)
            
                this.$store.dispatch('loginFromOktaToken',{'token': token.accessToken.value,
                    'parsedToken': token.accessToken,  'claims':claims})
            }
        },
        async fetchUserName(){
            const claims = await this.$auth.getUser()
            return claims.name

        },
        async fetchIsEnhanced(){
            const claims = await this.$auth.getUser()
            if(claims.isEnhanced == undefined) {
              console.log(`NOTE: Header.vue::fetchIsEnhanced`)
              this.$router.go() // This fixes a sync issue where we get this the user token, but it's not shown here.
            }
            return claims.isEnhanced

        },
        async fetchClientNAMES(){
            await this.fetchUserName()
            await this.isAuthenticated()
            await this.setup()
            this.$auth.authStateManager.subscribe(this.isAuthenticated)
            console.log(`NOTE: Header.vue::fetchClientNAMES`)
            //this.$router.go() // RGD: This is a hot spot.
            return this.$store.state.user.client_NAMES

        },
        async fetchUserRoles(){
            const claims = await this.$auth.getUser()
            return claims.roles

        },
        async fetchPriv(){
            const claims = await this.$auth.getUser()
            return claims.priviledges

        },
        async fetchClientId(){
            const claims = await this.$auth.getUser()
            return claims.clientId

        },
        async fetchClientName(){
            const token = await this.$auth.tokenManager.getTokens()
            return token.accessToken.claims.clientName
        },
        addClickOutsideToClose(){
          document.addEventListener('click', (e) => {
            const profileNav = document.getElementById('dropdownProfile')
            if(profileNav !== undefined && profileNav != null) {
              profileNav.classList.add('hidden')
              if(!profileNav.contains( event.target )) {
                document.getElementById('dropdownMenuitem').style.display = 'none';
              }
            }
            const profileNav2 = document.getElementById('dropdownProfile2')
            if(profileNav2 !== undefined && profileNav2 != null) {
              profileNav2.classList.add('hidden')
              if(!profileNav2.contains( event.target )) {
                document.getElementById('dropdownMenuitem2').style.display = 'none';
              }
            }
          })
        },
        showLossContent(){
            let elm = document.getElementsByClassName("loss-dropdown-content");
            elm[0].style.display==='none'?
            elm[0].style.display='block'
            : elm[0].style.display='none';
        },
        showContent(){
            let elm = document.getElementsByClassName("dropdown-content");
            elm[0].style.display==='none'?
            elm[0].style.display='block'
            : elm[0].style.display='none';
        },
        logout() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        },
        makeActive(selected) {
            this.headerItems.forEach(it=>{
                if(it.id===selected){
                    it.isActive=true;
                }
                else{
                    it.isActive=false;
                }
            })
        },
        activateDropDown(){
            this.chooseClient = true
            console.log("waitForToken:: activateDropDown")
            waitForToken()
            axiosRequests.get('/clients')
                .then(response => {
                    this.clientList = response.data
                })
        },
        changeClient($event){
            this.chooseClient=false 

            var clientIdx = $event.target.value
            var clientId = this.userInfo.client_IDS[clientIdx]
            var clientName = this.userInfo.client_NAMES[clientIdx]
            var payload = {"id": clientId, "name": clientName}
            console.log(`NOTE: ${clientId} ${clientId} ${clientName}`)
            //this.$store.state.clientId = clientId
            //this.$store.state.clientName = clientName
            localStorage.setItem("stateClient", clientId)
            localStorage.setItem("clientSelection", clientIdx)
            this.$store.commit('changeClient', {
              name: clientName,
              id: clientId
            })
        }
    },
}
</script>

<style src="@Style/header.css" scoped>
</style>

<style scoped>

.c-header__inner{
    display: contents;
}

.c-header__nav-container{
    align-self: center;
    float: right;
    justify-content: flex-end;
    margin-right: 4rem;
}

.vertical-separator {
  border-left: 0.75px solid #fff;
  height: 3rem;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  opacity: 0.35;
}

.c-primary-nav__item{
    display: inline-flex;
    max-width: none;
    margin-left: 2rem;
}

.c-header__nav-container{
    margin-top: 0.45rem;
}

.c-primary-nav__text{
    padding: 0 .5rem 0 0;
}

.active-tab{
    border-bottom: 4px solid #F5333F;
    width: 50%
}

.c-input--select{
    color: white;
    width:max-content;
    background-color: black;
    margin-right: 1rem;
}

.username-display{
    margin-right: 0.5rem;
    margin-block: auto;
}

.c-icon--large{
    min-width: 35px;
    cursor: pointer;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color:#fff;
    min-width: 15rem;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 99;
    border-radius: 6px;
    margin-left: -9rem;
    margin-top: 3rem;
}

.loss-dropdown-content {
    display: none;
    position: absolute;
    background-color:#fff;
    min-width: 15rem;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 100;
    border-radius: 6px;
    margin-left: -9rem;
    margin-top: 3rem;
}


.dropdown-content span {
    padding: .7rem;
    text-decoration: none;
    display: block;
}

.loss-dropdown-content span {
    padding: .7rem;
    text-decoration: none;
    display: block;
}

.menu-item--clickable:hover {
    background-color: #F5333F;
    color: white;
    border-radius: 4px;
}

.menu-item:hover {
    cursor: text
}

.dropdown:hover .dropdown-content {
    display: block;
}
.loss-dropdown:hover .dropdown-content {
    display: block;
}
.menu-item--clickable{
    color: #081F2D;
}
</style>
